const activeTransaction = state => {
    return state.availableTransactions[state.activeTransactionIndex]
}

const activeSearchModals = state => {
    let {
        showSearchType,
        showInternalCodeSearch,
        showMultiSelectSearch,
    } = state
    return showSearchType || showInternalCodeSearch || showMultiSelectSearch
}

export default {
    activeTransaction,
    activeSearchModals,
}
